export default function Marquee() {
  return null;
}
